import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { ChiamaAPI, Trad, BaseComponent, Tipo, CampoData, BottoneAPI } from '../components/';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import ChiamaWeb, { CChiamaWebParametri } from '../ChiamaWeb';

interface IEstrattoContoQuietanzeState {
    Caricamento: boolean;
    Dati?: Dati.CRisAPIListaEstrattoContoQuietanze;
    ID_AnagA?: number;
    DataDa?: Date;
    DataA?: Date;
    ID_AnagA_Prec?: number;
    DataDa_Prec?: Date;
    DataA_Prec?: Date;
    CorpoTabella?: React.ReactNode;
}

export class EstrattoContoQuietanze extends BaseComponent<Glob.IRouteGlobaleProps, IEstrattoContoQuietanzeState> {

    public constructor(props: any) {
        super(props);
        this.state = { Caricamento: false, ID_AnagA: undefined, DataDa: undefined, DataA: undefined };
        this.RiempiTabella = this.RiempiTabella.bind(this);
        this.OnErroreEstrattoConto = this.OnErroreEstrattoConto.bind(this);
        this.OnChange = this.OnChange.bind(this);
    }

    Tabella: any = null;

    private AttivaTabella() {
        if (this.state.Dati != undefined) {
            let T = $(this.refs.tabella);

            this.Tabella = T.DataTable({
                responsive: true,
                paging: false,
                searching: false,
                info: false,
                ordering: false,
                destroy: true
            });
        }
    }
    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
        this.CaricaListaQuietanze();
    }

    private TabellaVisibile() {
        return (this.state.ID_AnagA || 0) != 0 && this.state.DataDa != undefined && this.state.DataA != undefined;
    }

    private CaricaListaQuietanze() {
        if (!this.TabellaVisibile()) {
            return;
        }
        if (this.state.ID_AnagA != this.state.ID_AnagA_Prec || this.state.DataDa != this.state.DataDa_Prec || this.state.DataA != this.state.DataA_Prec) {
            this.setState({
                ID_AnagA_Prec: this.state.ID_AnagA,
                DataDa_Prec: this.state.DataDa,
                DataA_Prec: this.state.DataA
            });
        }
        else {
            return;
        }

        this.setState({ Caricamento: true });
        const ParamURL: { [Param: string]: any } = {};
        ParamURL["ID_AnagA"] = this.state.ID_AnagA;
        ParamURL["DataDa"] = Glob.DataValore(this.state.DataDa);
        ParamURL["DataA"] = Glob.DataValore(this.state.DataA);

        const Param: CChiamaWebParametri = {
            URL: "/api/EstrattoConto/ListaQuietanze",
            Metodo: "POST",
            ParamURLLista: ParamURL,
            OnRis: (sender: ChiamaWeb, dati: Dati.CRisAPIListaEstrattoContoQuietanze) => {
                this.setState({ Caricamento: false });
                if (dati.RisAPI.Errore) {
                    this.setState({ Dati: undefined });
                } else {
                    this.setState({ Dati: dati });
                }
            },
            OnErrore: (sender: ChiamaWeb, errore: Error) => {
                this.setState({ Caricamento: false, Dati: undefined });
            }
        };
        ChiamaWeb.ChiamaWeb(Param);
    }

    private RiempiTabella(dati?: Dati.CRisAPIListaEstrattoContoQuietanze): React.ReactNode {
        if (this.Tabella != null) {
            this.Tabella.destroy();
        }

        if (!this.TabellaVisibile()) {
            return;
        }

        if (this.state.Caricamento) {
            return <tbody><tr><td colSpan={11}>{Trad.Trad("Caricamento")}</td></tr></tbody>;
        }

        if (dati == undefined || dati.RisAPI.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={11} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return <tbody>
                {dati.RisAPI.Dati.map((dato, index) =>
                    <tr key={dato.ID_Quietanza}>
                        <td className="TextLeft">{Trad.TradParam("DataEmissione{1-D}", [dato.DataEmissione])}<br />{Trad.TradParam("DataRichiestoPagamento{1-D}", [dato.DataRichiestoPagamento])}<br />{Trad.TradParam("DataPagamento{1-D}", [dato.DataPagamento])}<br /></td>
                        <td className="TextCenter">{dato.ID_EstrattoConto}</td>
                        <td className="TextCenter">{dato.Polizza}</td>
                        <td className="TextLeft">{dato.AnagContraente}</td>
                        <td className="TextLeft">{dato.Compagnia}<br />{dato.TipoRamo}<br />{dato.TipoProdotto}</td>
                        <td className="TextRight">{Trad.TradParam("{1-I}", [dato.PremioLordoDare])}</td>
                        <td className="TextRight">{Trad.TradParam("{1-I}", [dato.ProvvigioniDare])}</td>
                        <td className="TextRight">{Trad.TradParam("{1-I}", [dato.PremioLordoAvere])}</td>
                        <td className="TextRight">{Trad.TradParam("{1-I}", [dato.ProvvigioniAvere])}</td>
                        <td className="TextRight">{this.StampaExtra(dato.Extra)}</td>
                        <td className="TextCenter">
                            <input name={"RisAPI.Dati[" + index + "].Selezionata"} type="checkbox" onChange={(e) => this.OnChange(e)} checked={dato.Selezionata} disabled={dato.ID_EstrattoConto != undefined} />
                        </td>
                    </tr>
                )}
            </tbody>;
        }
    }

    private StampaExtra(extra: Dati.CDatiQuietanzeEstrattoImportiExtra[]): string {
        let R = "";

        for (const E in extra) {
            R += extra[E].Nome + " " + Trad.TradParam("{1-I}", [extra[E].Importo]);
        }

        return R;
    }

    private OnErroreEstrattoConto(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={11}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    public render() {
        if (!this.ControlloAutorizzazione("EstrattoContoController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }
        if (!Glob.AzioneAbilitata("EstrattoContoController", Glob.Scrittura)) {
            this.props.history.push("/EstrattoConto");
            return false;
        }

        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-handshake"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("EstrattoContoQuietanze")}</h3>
                    </div>
                </div>
            </div>
            <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row dashed-border-bottom">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("DataDa")}</label>
                        <div className="col-lg-2 form-control-plaintext">
                            <div className="form-control">
                                <CampoData ValoreInArrivo={false}
                                    Name="DataDa"
                                    Id="DataDa"
                                    Valore={this.state.DataDa}
                                    OnChange={this.OnChange} />
                            </div>
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("DataA")}</label>
                        <div className="col-lg-2 form-control-plaintext">
                            <div className="form-control">
                                <CampoData ValoreInArrivo={false}
                                    Name="DataA"
                                    Id="DataA"
                                    Valore={this.state.DataA}
                                    OnChange={this.OnChange} />
                            </div>
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("A")}</label>
                        <div className="col-lg-5 form-control-plaintext">
                            <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="ID_AnagA" ID_Chiave={this.state.ID_AnagA} OnAggiorna={this.OnChange} TradValori />
                        </div>
                    </div>
                </div>
            </form>
            {this.TabellaVisibile() &&
                <>
                    <div>
                        <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                            <thead>
                                <tr className="sfondoTab">
                                    <th scope="row" className="TextLeft">{Trad.Trad("Date")}</th>
                                    <th scope="row" className="TextCenter">{Trad.Trad("E.C.")}</th>
                                    <th scope="row" className="TextCenter">{Trad.Trad("Polizza")}</th>
                                    <th scope="row" className="TextCenter">{Trad.Trad("Contraente")}</th>
                                    <th scope="row" className="TextCenter">{Trad.Trad("TipoProdotto")}</th>
                                    <th scope="row" className="TextCenter">{Trad.Trad("PremioLordoDare")}</th>
                                    <th scope="row" className="TextCenter">{Trad.Trad("ProvvigioniDare")}</th>
                                    <th scope="row" className="TextCenter">{Trad.Trad("PremioLordoAvere")}</th>
                                    <th scope="row" className="TextCenter">{Trad.Trad("ProvvigioniAvere")}</th>
                                    <th scope="row" className="TextCenter">{Trad.Trad("Extra")}</th>
                                    <th data-field="edit" className="TextCenter">{Trad.Trad("Seleziona")}</th>
                                </tr>
                            </thead>
                            {this.RiempiTabella(this.state.Dati)}
                        </table>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--left">
                            <div className="col kt-form__actions kt-form__actions--left row">
                                <div className="col-lg-3 kt--align-left">
                                    {Trad.TradParam("TotalePremioLordoDare{1-I}", [this.TotalePremioLordoDare()])}<br />
                                    {Trad.TradParam("TotaleProvvigioniDare{1-I}", [this.TotaleProvvigioniDare()])}<br />
                                    {Trad.TradParam("TotalePremioLordoAvere{1-I}", [this.TotalePremioLordoAvere()])}<br />
                                    {Trad.TradParam("TotaleProvvigioniAvere{1-I}", [this.TotaleProvvigioniAvere()])}<br />
                                </div>
                                <div className="col-lg-3 kt--align-left">
                                    <BottoneAPI
                                        Default={false}
                                        Testo={Trad.Trad("Crea")}
                                        URL="/api/EstrattoConto/Crea"
                                        Metodo="POST"
                                        OnInvio={s => this.OnInvioBottoneAPI(s)}
                                        OnClick={(s, d) => this.OnClickBottoneAPI(s, d)}
                                        OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)}
                                        DataDismiss="modal"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>;
    }

    OnClickBottoneAPI(s: BottoneAPI, dati: Dati.CRisAPI): void {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("EstrattoContoErrore"), Trad.Trad(dati.ErrTesto));
        } else {
            Glob.InfoModaleSuccess(Trad.Trad("EstrattoConto"), Trad.Trad("EstrattoContoCreato") + ": " + dati.ID_Chiave, () => this.props.history.push("/EstrattoConto/" + dati.ID_Chiave));
        }
    }

    private OnInvioBottoneAPI(s: BottoneAPI): Dati.CIngrAPIExtra<Dati.CIngrAPILista<Dati.CDatiQuietanzeEstrattoConto>, Dati.CDatiQuietanzeEstrattoContoIngrExtra> {
        const Ingr = new Dati.CIngrAPIExtra<Dati.CIngrAPILista<Dati.CDatiQuietanzeEstrattoConto>, Dati.CDatiQuietanzeEstrattoContoIngrExtra>();
        if (this.state.Dati?.RisAPI.Dati != null) {
            Ingr.IngrApi.Dati = this.state.Dati?.RisAPI.Dati;
            Ingr.Extra.DataA = this.state.DataA!;
            Ingr.Extra.DataDa = this.state.DataDa!;
            Ingr.Extra.ID_AnagA = this.state.ID_AnagA!;
        }
        return Ingr;
    }

    private OnErroreBottoneAPI(s: BottoneAPI, e: Error): void {
        Glob.InfoModaleError(Trad.Trad("EstrattoContoErrore"), e.message);
    }

    private TotalePremioLordoDare(): number {
        let R = 0;
        this.state.Dati?.RisAPI.Dati.map(Q => {
            R += Q.Selezionata ? Q.PremioLordoDare : 0;
        });
        return R;
    }

    private TotaleProvvigioniDare(): number {
        let R = 0;
        this.state.Dati?.RisAPI.Dati.map(Q => {
            R += Q.Selezionata ? Q.ProvvigioniDare : 0;
        });
        return R;
    }

    private TotalePremioLordoAvere(): number {
        let R = 0;
        this.state.Dati?.RisAPI.Dati.map(Q => {
            R += Q.Selezionata ? Q.PremioLordoAvere : 0;
        });
        return R;
    }

    private TotaleProvvigioniAvere(): number {
        let R = 0;
        this.state.Dati?.RisAPI.Dati.map(Q => {
            R += Q.Selezionata ? Q.ProvvigioniAvere : 0;
        });
        return R;
    }
}



// WEBPACK FOOTER //
// ./src/form/EstrattoContoQuietanze.tsx